import React from "react";
import styles from "./dashboard/Styles";
import {
  GET_ONE,
  GET_LIST,
  UPDATE,
  SimpleForm,
  FunctionField,
  Responsive,
  SaveButton,
  showNotification
} from "react-admin";

import { connect } from "react-redux";
import { change, submit } from "redux-form";
import moment from "moment";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import dataProviderFactory from "../dataProvider";
import ChargesGrid from "../components/listCharges";

import Paper from "@material-ui/core/Paper";
import { parse } from "query-string";

import {
  Card,
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControlLabel,
  Switch,
  CardContent,
  Typography,
  LinearProgress,
  Checkbox,
  Grid,
  Button,
} from "@material-ui/core";

import {
  map,
  length,
  head,
  filter,
  prop,
  propEq,
  find,
  isNil,
  isEmpty,
  sum,
  path, 
  allPass
} from "ramda";
import { isNull } from "util";
import * as R from "ramda" 

//add suplement charge a rental price
import AddSuplementCharge from "../components/addSuplementCharge";
import ClientDocumentsModal from "./ClientDocumentsModal";
import { documentTarget } from "../utils/agencyRiderDocuments";
import ProfileCompleteMark from "./profileCompleteMark";
import { DATEFORMAT } from "../date-config";
import { getPermissionRole } from "../util";

const StyledSelect = styled(Select)`
  width: 256px !important;
`;

const StyledSpan = styled.div`
  color: red;
  padding: 10px;
  width: 100% !important;
`;
const StyledP = styled(FunctionField)`
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100% !important;
`;

let rentalTotalSubmit = 0, toRefundValue = 0, extraChargesValue = 0
let valueToCharge = 0, addSuplement = false
class ProcessTourEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      r_insurance_disabled: false,
      r_gps_disabled: false,
      refund_value: 0,
      chargeId: 0,
      isOnSubmit: false,
      driver_id: 0,
      comment: "",
      invoice_comments: "",
      imt_commentN: "",
      imt_comment: "",
      extra_comments: "",
      r_cancel_insurance: false,
      low_seat: false,
      r_single: false,
      chargeTypeId: "2",
      location_id_1: 0,
      location_id_2: 0,
      time_1: 0,
      time_2: 0,
      date_1: null,
      date_2: null,
      r_gps: false,
      rewards: 0,
      r_insurance: false,
      vehicle_model_1: 0,
      vehicle_model_2: 0,
      vehicleId: 0,
      gpsDeviceId: 0,
      discount: 0,
      partial: 0,
      checkedF: false,
      resend: false,
      rental: null,
      error: false,
      sendFinalConfirmation: false, valid_charge: false,
      form_error: false,
      chargeSuplement: 0,
      valueAvalaible: 0,
      clientDocumentsModalOpen: false,
    };
  }

  async getGpsDevices() {
    const { rental } = this.state;
    const dataProvider = await dataProviderFactory("rest");
    const responseGps = await dataProvider(GET_LIST, "gps_devices", {
      filter: {
        tour_id: rental.booking.tour_id,
        availability: true
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });
    return responseGps;
  }

  async gpsPrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const gpsPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "gps_device",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return gpsPrices;
  }

  async insurancePrices(date) {
    const dataProvider = await dataProviderFactory("rest");
    const insurancePrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        price_item_type: "insurance",
        for_date: date,
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "start_date", order: "DESC" }
    });
    return insurancePrices;
  }

  getModelName1() {
    const { models, vehicle_model_1 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));
    return selectedModel.model_name;
  }

  getModelName2() {
    const { models, vehicle_model_2 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_2), models));
    return selectedModel.model_name;
  }

  async getModelPrices1() {
    const { models, tourPrices, vehicle_model_1 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_1), models));

    if (selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    const selectedUpPrice = head(
      filter(
        propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`),
        tourPrices
      )
    );
    return selectedUpPrice.price;
  }

  async getModelPrices2() {
    const { models, tourPrices, vehicle_model_2 } = this.state;
    const selectedModel = head(filter(propEq("id", vehicle_model_2), models));

    if (selectedModel.model_name === "Own Motorcycle") {
      return 0;
    }

    const selectedUpPrice = head(
      filter(
        propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`),
        tourPrices
      )
    );
    return selectedUpPrice.price;
  }

  async getHolidays1() {
    const { location_id_1 } = this.state;
    return this.getHolidays(location_id_1);
  }

  async getHolidays2() {
    const { location_id_2 } = this.state;
    return this.getHolidays(location_id_2);
  }

  async getHolidays(locationId) {
    const { date_1, date_2 } = this.state;

    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: date_1,
        endDate: date_2,
        location_id: locationId
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    return holidays;
  }

  async getVehicles() {
    const { rental, vehicle_model_1 } = this.state;
    const dataProvider = await dataProviderFactory("rest");
    const responseVehicles = await dataProvider(GET_LIST, "vehicles", {
      filter: {
        availability: true,
        tour_id: rental.booking.tour_id,
        vehicle_model_id: vehicle_model_1
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });
    return responseVehicles;
  }

  async fetchData(id) {
    const dataProvider = await dataProviderFactory("rest");
    const responseRental = await dataProvider(GET_ONE, `tour_clients`, {
      id
    });

    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_2" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const selectedModelOwn = head(
      filter(propEq("model_name", "Own Motorcycle"), vehicleModels.data)
    );

    const selectedVehicle = isEmpty(responseRental.data.vehicle)
      ? null
      : head(prop("vehicle", responseRental.data));

    const priceDate = path(['booking', 'price_date'], responseRental.data);

    const responseTourPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: priceDate,
        for_tour_id: responseRental.data.booking.tour_id,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: {}
    });

    const responseLocations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const selectedGpsDevice = head(responseRental.data.device) || { id: 0 };
    const gpsPrices = await this.gpsPrices(priceDate);
    const hollidays1 = this.getHolidays1();
    const hollidays2 = this.getHolidays2();
    const insurancePrices = await this.insurancePrices(priceDate);

    const charge = prop("charges", head(responseRental.data.payments));
    let suplementRemeaning = 0
    let chargeNotPayedSuplemento = charge.filter(function (c) {
      if (c.status == false && c.extra_charge == true) {
        return suplementRemeaning = suplementRemeaning + c.value;
      }
    })

    this.setState(
      {
        gpsDeviceId: selectedGpsDevice.id,
        driver_id: responseRental.data.driver.id,
        rewards: responseRental.data.booking.rewards,
        vehicle_model_1: isNil(selectedVehicle)
          ? selectedModelOwn.id
          : selectedVehicle.vehicle_model_id,
        vehicle_model_2: responseRental.data.booking.vehicle_model_2,
        location_id_1: responseRental.data.location_id_1,
        location_id_2: responseRental.data.location_id_2,
        vehicleId: prop("id", head(responseRental.data.vehicle)),
        date_1: responseRental.data.date_1,
        date_2: responseRental.data.date_2,
        time_1: responseRental.data.time_1,
        time_2: responseRental.data.time_2,
        low_seat: responseRental.data.seat.length > 0,
        gpsPrices: gpsPrices.data,
        hollidays1,
        hollidays2,
        insurancePrices: insurancePrices.data,
        imt_commentN: responseRental.data.imt_comment,
        comment: responseRental.data.comment,
        discount: responseRental.data.discount,
        extra_comments: responseRental.data.extra_comments,
        r_single: responseRental.data.single.length > 0,
        r_double: !(responseRental.data.single.length > 0),
        r_gps: responseRental.data.device.length > 0,
        r_cancel_insurance: responseRental.data.cancel_insurance.length > 0,
        r_insurance: responseRental.data.insurance.length > 0,
        r_documentacion: responseRental.data.r_documentacion,
        rental: responseRental.data,
        locations: responseLocations.data,
        tourPrices: responseTourPrices.data,
        models: vehicleModels.data,
        chargeSuplement: suplementRemeaning
        // chargeTypeId:
        //   this.isUserStripe() && !responseRental.data.booking.p4m ? "1" : "2"
      },

      async () => {
        const [
          vehicles,
          model1Price,
          model2Price,
          gpsDevices
        ] = await Promise.all([
          this.getVehicles(),
          this.getModelPrices1(),
          this.getModelPrices2(),
          this.getGpsDevices()
        ]);

        if (selectedGpsDevice.id === this.state.gpsDeviceId) {
          gpsDevices.data.push({
            id: selectedGpsDevice.id,
            model: selectedGpsDevice.model
          });
        }

        if (
          !isNil(selectedVehicle) &&
          selectedVehicle.vehicle_model_id === this.state.vehicle_model_1
        ) {
          vehicles.data.push({
            created_at: selectedVehicle.created_at,
            date_2: "",
            express_invoice_id: null,
            express_invoice_url: null,
            financing: 0,
            financing_details: "",
            id: selectedVehicle.id,
            insurance_date: null,
            insurance_policy: null,
            insurance_status_id: null,
            item_id: selectedVehicle.id,
            licence_plate: selectedVehicle.licence_plate,
            location_id_2: 0,
            location_name: 0,
            low: 0,
            number_rentals: 0,
            purchase_date: null,
            purchase_price: 0,
            purchased_from: 0,
            renting: 0,
            retirement_date: null,
            sale_date: null,
            sale_price: 0,
            sold_to: null,
            updated_at: selectedVehicle.updated_at,
            vechicle_chassis: selectedVehicle.vechicle_chassis,
            vehicle_color: selectedVehicle.vehicle_color,
            vehicle_mileage: selectedVehicle.vehicle_mileage,
            vehicle_model_id: selectedVehicle.vehicle_model_id,
            vehicle_options: selectedVehicle.vehicle_options,
            vehicle_status_id: selectedVehicle.vehicle_status_id,
            vehicle_year: selectedVehicle.vehicle_year
          });
        }
        this.setState({
          r_insurance_disabled: this.getModelName1() === "Own Motorcycle",
          r_gps_disabled: this.getModelName1() === "K1600GT",
          vehicles: vehicles.data,
          gpsDevices: gpsDevices.data,
          model1Price,
          model2Price
        });
      }
    );
  }

  async componentDidUpdate() {
    const { id } = this.props.match.params;
    if (isNull(this.state.rental)) {
      await this.fetchData(id);
    }
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    if (isNull(this.state.rental)) {
      await this.fetchData(id);
    }
  }

  getStripeType(rental) {
    if (!isNil(rental.booking.tour_id) && rental.booking.tour_id > 0) {
      return rental.booking.p4m ? "p4m" : "tours";
    }
  }

  isUserStripe = () => {
    const { rental } = this.state;
    let stripToUse = null;
    if (!isNil(rental)) {
      const stripeType = this.getStripeType(rental);
      if (stripeType !== "p4m") {
        stripToUse = prop(`stripe_${stripeType}`, rental.driver);
      }
    }
    return !isNil(stripToUse);
  };

  duration = (date1, date2, forEffective = false) => {
    let days = moment.utc(date2).diff(date1, "days");//eliminamos el dia que se agrega
    if(forEffective){
      days += 1
    }
    return days || 0;
  };

  getModelName = modelId => {
    const { models } = this.state;
    return prop("model_name", find(propEq("id", modelId), models));
  };

  handleCheckChangeConfirm = (event, valueToConfirm) => {
    if (this.state.discount === valueToConfirm) {
      valueToConfirm = 0
    }
    if(event.target.checked){
      this.setState({
        [event.target.name]: event.target.checked,
        partial: valueToConfirm
      });
    }else{
      this.setState({
        [event.target.name]: event.target.checked,
        partial: 0
      });
    }
    this.setState({
      valueAvalaible: valueToConfirm
    });


    if(event.target.checked){

      if(valueToConfirm <= 0){
        this.setState({form_error: true})
      }else{
        this.setState({form_error: false})
      }
    }else{
      this.setState({form_error: false})
    }
    
  };

  handleCheckResendConfirm = (event) => {
    this.setState({
      [event.target.name]: event.target.checked
    });
  };

  handleSendEmailCheckChange = event => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  handleCheckChange = event => {
    if (event.target.name === "r_double") {
      if (event.target.checked) {
        this.setState({
          r_single: false,
          checkedF: false,
          partial: 0
        });
      } else {
        this.setState({
          r_single: true,
          checkedF: false,
          partial: 0
        });
      }
    }

    if (event.target.name === "r_single") {
      if (event.target.checked) {
        this.setState({
          r_double: false,
          checkedF: false,
          partial: 0
        });
      } else {
        this.setState({
          r_double: true,
          checkedF: false,
          partial: 0
        });
      }
    }

    this.setState({
      [event.target.name]: event.target.checked,
      checkedF: false,
      partial: 0
    });

    if (event.target.name === "r_gps") {
      this.setState({
        gpsDeviceId: 0
      });
    }
  };

  handleChange = (element, type) => {
    this.setState(
      {
        [type]: element.target.value,
        checkedF: false,
        partial: 0
      },
      async () => {
        const [updatedVehicles, updatedGps] = await Promise.all([
          this.getVehicles(),
          this.getGpsDevices()
        ]);

        this.setState({
          vehicleId: 0,
          gpsDeviceId: 0,
          vehicles: updatedVehicles.data,
          gpsDevices: updatedGps.data
        });
      }
    );
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("process-rental");
    });
  };

  handleSubmit = async () => {
    //console.log(this.state);
    const {
      discount,
      partial,
      checkedF,
      resend,
      rental,
      vehicleId,
      date_1,
      date_2,
      time_1,
      time_2,
      r_single,
      chargeId,
      imt_comment,
      extra_comments,
      location_id_1,
      location_id_2,
      chargeTypeId,
      low_seat,
      comment,
      gpsDeviceId,
      r_gps,
      r_insurance,
      r_documentacion,
      r_cancel_insurance,
      vehicle_model_1,
      rewards,
      invoice_comments,
      refund_value,
      sendFinalConfirmation,
      chargeSuplement
    } = this.state;

    const bodyRequest = {
      id: rental.id,
      data: {
        id: rental.id,
        driver_id: rental.client_id,
        charge_id: chargeId,
        refund_value,
        discount,//:  discount > rental.discount ? parseFloat(discount) : 0 ,
        partial,
        checkedF,
        resend,
        vehicle_id: vehicleId,
        date_1,
        date_2,
        time_1,
        time_2,
        location_id_1,
        location_id_2,
        charge_type_id: chargeTypeId,
        comment,
        imt_comment,
        invoice_comments,
        extra_comments,
        gpsdevice_id: gpsDeviceId,
        r_insurance,
        vehicle_model_id: vehicle_model_1,
        rewards,
        r_gps: this.getModelName1() === "K1600GT" ? true : r_gps,
        low_seat,
        r_single,
        r_cancel_insurance,
        r_documentacion,
        sendFinalConfirmation,
        rentalTotalSubmit,
        toRefundValue, 
        addSuplement: checkedF && chargeSuplement > 0 ? true : false, 
        extraChargesValue: checkedF && chargeSuplement > 0 ? chargeSuplement : 0 
      }
    };

    const from = this.props.location.search || null;
    const newStr = from != null ? from.substring(6) : null
    const redirect = newStr ? newStr : "tour_list";

    const dataProvider = await dataProviderFactory("rest");
    dataProvider(UPDATE, "tour_clients", bodyRequest)
      .then(() => {
        this.setState({
          availableItems: {},
          data: {},
          events: {},
          newItem: 0
        });
        const { history } = this.props;
        history.replace(`/${redirect}`);
      })
      .catch(error => {
        console.log("error", error)
        this.setState({ isOnSubmit: false });
        this.props.showNotification(error.message, "error");
      });
  };

  isWeekEnd = curDay => {
    const date1 = moment(curDay);
    return date1.weekday() === 6 || date1.weekday() === 0;
  };

  isHoliday = (curDay, items) => {
    const hasHollidays = [];
    map(hd => {
      const date1 = moment(hd.date).format("YYYY-MM-DD");
      const date2 = curDay.format("YYYY-MM-DD");
      if (date1 === date2 || curDay.weekday() === 6 || curDay.weekday() === 7) {
        hasHollidays.push(hd);
      }
    }, items || []);
    return length(hasHollidays) > 0;
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value });
    if(type === "partial"){
      const {rental} = this.state
      const charges = prop("charges", head(rental.payments))
      const pendingValue = sum(map(prop("value"), filter(propEq("status", false), charges)))

      const valueRemaining = this.state.valueAvalaible
      if(parseFloat(element.target.value) > parseFloat(valueRemaining) || parseFloat(element.target.value) <= pendingValue){
        this.setState({form_error: true})
      }else{
        this.setState({form_error: false})
      }
    }
  };

  handelModelChange = element => {
    this.setState(
      {
        partial: 0,
        checkedF: false,
        vehicle_model_1: element.target.value,
        vehicles: [],
        model1Price: 0,
        model2Price: 0,
        vehicleId: 0
      },
      async () => {
        const selectedVehicle = head(this.state.rental.vehicle) || {};
        const updatedVehicles = await this.getVehicles();
        const updatedModelPrice1 = await this.getModelPrices1();
        const updatedModelPrice2 = await this.getModelPrices2();

        if (selectedVehicle.vehicle_model_id === this.state.vehicle_model_1) {
          updatedVehicles.data.push({
            created_at: selectedVehicle.created_at,
            date_2: "",
            express_invoice_id: null,
            express_invoice_url: null,
            financing: 0,
            financing_details: "",
            id: selectedVehicle.id,
            insurance_date: null,
            insurance_policy: null,
            insurance_status_id: null,
            item_id: selectedVehicle.id,
            licence_plate: selectedVehicle.licence_plate,
            location_id_2: 0,
            location_name: 0,
            low: 0,
            number_rentals: 0,
            purchase_date: null,
            purchase_price: 0,
            purchased_from: 0,
            renting: 0,
            retirement_date: null,
            sale_date: null,
            sale_price: 0,
            sold_to: null,
            updated_at: selectedVehicle.updated_at,
            vechicle_chassis: selectedVehicle.vechicle_chassis,
            vehicle_color: selectedVehicle.vehicle_color,
            vehicle_mileage: selectedVehicle.vehicle_mileage,
            vehicle_model_id: selectedVehicle.vehicle_model_id,
            vehicle_options: selectedVehicle.vehicle_options,
            vehicle_status_id: selectedVehicle.vehicle_status_id,
            vehicle_year: selectedVehicle.vehicle_year
          });
        }

        this.setState({
          vehicles: updatedVehicles.data,
          model1Price: updatedModelPrice1,
          model2Price: updatedModelPrice2,
          r_insurance_disabled: this.getModelName1() === "Own Motorcycle",
          r_gps: this.getModelName1() === "K1600GT" ? true : this.state.r_gps,
          r_gps_disabled: this.getModelName1() === "K1600GT",
          r_insurance:
            this.getModelName1() === "Own Motorcycle"
              ? false
              : this.state.r_insurance,
          gpsDeviceId:
            this.getModelName1() === "K1600GT" ? 0 : this.state.gpsDeviceId
        });
      }
    );
  };

  validateDates = () => {
    const { date_1, date_2 } = this.state;
    const d2 = moment(date_2);
    const d1 = moment(date_1);
    return d2.isAfter(d1);
  };

  is1600Gt = () => {
    return this.getModelName(this.state.vehicle_model_1) === "K1600GT";
  };

  chargeTypeId = rental => {
    const chargeTypes = [
      { id: "1", _id: "1", description: "Stripe" },
      { id: "2", _id: "2", description: "Other (Money, bank transfer)" }
    ];
    return (
      <div>
        <InputLabel htmlFor="charge-simple">Charge Type</InputLabel> <br />
        <StyledSelect
          onChange={e => this.handleChangeItem(e, "chargeTypeId")}
          inputProps={{
            name: "charge",
            id: "charge-simple"
          }}
          value={this.state.chargeTypeId}
          disabled={!this.isUserStripe() || rental.booking.p4m}
        >
          {map(item => {
            return (
              <MenuItem key={item._id} value={item._id}>
                {item.description}
              </MenuItem>
            );
          }, chargeTypes)}
        </StyledSelect>
        <br />
      </div>
    );
  };

  checkOneDay = (bike) => {
    //let nextDay = new Date(Date.parse(bike.date_2));
    const date2 = Date.parse(this.state.date_2);
    let nextDay = new Date(date2); // no usar bike no trae la fecha date_2
    nextDay.setDate(nextDay.getDate() + 1);
    if (nextDay.toISOString().slice(0, 10) === this.state.date_1) {
      return true
    } else {
      return false
    }
  }

  render() {
    if (isNil(this.state.rental) || isNil(this.state.vehicles)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const {
      rental,
      models,
      vehicles,
      gpsDevices,
      model1Price,
      model2Price,
      date_1,
      date_2,
      gpsPrices,
      insurancePrices,
      r_cancel_insurance,
      r_insurance,
      r_gps,
      r_single,
      discount,
      hollidays1,
      hollidays2,
      isOnSubmit,
      tourPrices,
      rewards,
      chargeId,
  
      partial,
      checkedF,
      resend
    } = this.state;

    const charges = prop("charges", head(rental.payments));
    const refund_value = parseFloat(this.state.refund_value, 0) || 0;

    let passenger=true;
    let valueRemaining = 0;
    let gpsPrice = 0;
    let singlePrice = 0;
    let rentalTotal1 = 0;
    let tourTotal = 0;
    let rentalTotal2 = 0;
    let vipInsurancePrice = 0;
    let passengerPrice = 0;
    let tourPassengerPrice = 0;
    let cancelInsurancePercentage = 0;
    let cancelInsuranceValue1 = 0;
    let cancelInsuranceValue2 = 0;
    const selectedVehicle = head(rental.vehicle);
    let maxRefundValue = 0;
    let rentalDays = this.duration(rental.booking.tour.tour_start_date, rental.booking.tour.tour_end_date);

    let effective_start = moment(rental.booking.tour.effective_start_date).utc()
    let effective_end = moment(rental.booking.tour.effective_end_date).utc()
    let efectiveDays = this.duration(effective_start, effective_end, true)

    let chargesFiltered = [];
   
    let selectdCharge = 0;
    let availableChargeValue = 0;
    let double=true;


    const totalRefunded =
      sum(
        map(
          prop("refunded_value"),
          filter(
            propEq("status", true),
            filter(propEq("to_refund", true), charges)
          )
        )
      ) || 0;

    const totalPayed = sum(map(prop("value"), filter(propEq("status", true), charges))) - totalRefunded;
    const pendingSuplement = sum(map(prop("value"), filter(allPass([propEq("status", false), propEq("extra_charge", true)]), charges)))
    const payedSuplement = sum(map(prop("value"), filter(allPass([propEq("status", true), propEq("extra_charge", true)]), charges)))
    const hasSuplement = sum(map(prop("value"), filter(propEq("extra_charge", true), charges)));

    if (rentalDays > 0 && !isNil(rentalDays)) {
      singlePrice = r_single
        ? prop(
          "price",
          head(
            filter(propEq("price_item_sub_type", "tour_single"), tourPrices)
          )
        )
        : 0;

      tourTotal = prop(
        "price",
        head(filter(propEq("price_item_sub_type", "tour_total"), tourPrices))
      );

      tourPassengerPrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_passenger"), tourPrices)
        )
      );

      passengerPrice =
        !isNil(rental.booking.p_first_name) &&
          !isEmpty(rental.booking.p_first_name)
          ? tourPassengerPrice
          : 0;

      gpsPrice = r_gps
        ? prop(
          "price",
          head(
            filter(propEq("price_item_type", "gps_device"), gpsPrices)
          )
        )
        : 0;

      if (r_gps && this.is1600Gt()) {
        gpsPrice = 0;
      }

      vipInsurancePrice = r_insurance
        ? prop(
          "price",
          head(
            filter(
              propEq("price_item_id", 1),
              filter(propEq("price_item_type", "insurance"), insurancePrices)
            )
          )
        )
        : 0;

      cancelInsurancePercentage = r_cancel_insurance
        ? prop(
          "percentage",
          head(filter(propEq("price_item_id", 3), insurancePrices))
        )
        : 0;

      let tourTotal1 =
        this.getModelName1() === "Own Motorcycle"
          ? tourPassengerPrice +500
          : tourTotal;

      // cancelInsuranceValue1 = r_cancel_insurance
      //   ? prop(
      //       "price",
      //       // head(filter(propEq("price_item_id", 3), rental.items.rows))
      //       head(
      //         filter(
      //           propEq("rental_item_type", "insurance"),
      //           filter(obj => obj.price > 20, rental.items.rows)
      //         )
      //       )
      //     )
      //   : 0;
      cancelInsuranceValue1 = r_cancel_insurance
        ? ((tourTotal1 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model1Price) *
          cancelInsurancePercentage) /
        100
        : 0;

      rentalTotal1 = (
        cancelInsuranceValue1 +
        (tourTotal1 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          vipInsurancePrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model1Price) -
        rewards
      ).toFixed(2);
      rentalTotalSubmit = rentalTotal1
      let tourTotal2 =
        this.getModelName2() === "Own Motorcycle"
          ? tourPassengerPrice + 500
          : tourTotal;

      cancelInsuranceValue2 = r_cancel_insurance
        ? ((tourTotal2 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model2Price) *
          cancelInsurancePercentage) /
        100
        : 0;

      rentalTotal2 = (
        cancelInsuranceValue2 +
        (tourTotal2 +
          gpsPrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          vipInsurancePrice * efectiveDays + //cambiamos rentalDays por efectiveDays
          passengerPrice +
          singlePrice +
          model2Price) -
        rewards
      ).toFixed(2);
      maxRefundValue = rental.rental_price.toFixed(2) - rentalTotal1;
      toRefundValue = maxRefundValue
      const valueForFirst = parseFloat(rentalTotal1) + parseFloat(payedSuplement)
      valueRemaining = (valueForFirst - totalPayed) - discount + parseFloat(pendingSuplement.toFixed(2));
      chargesFiltered =
        filter(
          obj =>
            obj.value.toFixed(2) - obj.refunded_value.toFixed(2) >=
            maxRefundValue.toFixed(2),
          filter(
            propEq("status", true),
            filter(obj => obj.refunded_value <= obj.value, charges)
          )
        ) || [];
    }

    selectdCharge = head(filter(propEq("id", chargeId), chargesFiltered));

    availableChargeValue =
      prop("value", selectdCharge) - prop("refunded_value", selectdCharge) || 0;
    let dayActual = moment(Date.now()).format("YYYY-MM-DD")


    valueToCharge = this.state.partial == 0 ? valueRemaining : this.state.partial
    let valid_charge = false
    if (this.state.partial > 0) {
      valid_charge = true
    }

    let valueReamaningRentalPrice = rental.rental_price - totalPayed - totalRefunded
    let extraCharges = 0
    let valueRemainingText = valueRemaining

    //let chargeNotPayedSuplemento = charges.filter(c => c.status == false && c.extra_charge == true)
    let suplementSum = 0
    let chargeNotPayedSuplemento = charges.filter(function (c) {
      if (c.status == false && c.extra_charge == true) {
        return suplementSum = suplementSum + c.value;
      }
    })
    console.log("suplementSum",suplementSum)
    console.log("pendingSuplement",pendingSuplement)


    if (rental.payed) {
      extraCharges = suplementSum
      if (extraCharges > 0) {
        addSuplement = true
        extraChargesValue = extraCharges
      }
      //valueRemaining = valueRemaining + extraCharges
    }
    else {
      extraCharges = suplementSum
      if (extraCharges > 0) {
        addSuplement = true;
        extraChargesValue = extraCharges;
      }
      //valueRemaining = valueRemaining + extraCharges;
    }


/*
 if(!this.state.r_double)
         {
         passenger=true;
          }
      else
         {   
             passenger=false;
          }
*/

/*
    if(!(rental.booking.p_first_name)){
      passenger=false;
  }
  
    
   
  if (!isNil(rental.booking.p_firs_name)) {
    if (rental.booking.p_firs_name.length === 0) {
      passenger = false;
    } else {
      passenger = true;
    }
  }
  */
  




/*
  const longitud = rental.booking.roommate.length;
  const singleVal=this.state.r_single;
  const doubleVal=this.state.r_double;

  if (longitud > 1) {
   
    console.log("El texto tiene más de 1 caracter");
    passenger = true;
  }
  else{
    passenger = false;
  }
if((doubleVal==true)&& (passenger==true))
  {
    passenger=true;
  }
  else if((singleVal==true)&& (passenger==true)){
    passenger=false;
  }
  else if((doubleVal==true)&& (passenger==false)){
    passenger=false;
  }
  else
    { 
    passenger=true;
    }
*/
if (!isNil(rental.booking.p_firs_name)) {
 const long = rental.booking.p_first_name.length;

  if (long> 1) {
   
    console.log("El texto tiene más de 1 caracter");
    passenger = true;
  }
  else
  {
    passenger = false;
  }
}
else{
  passenger = false;
}

    return (
      <React.Fragment>
      <Card>
        <CardContent>
          <Typography
            gutterBottom
            variant="display3"
            component="h2"
            style={styles.cardHeaderStyle}
          >
            Processing Edit - Tour Booking For:{" "}
            <b>
              {rental.booking.r_first_name} {rental.booking.r_last_name}
            </b>
            <ProfileCompleteMark record={rental} size={28} />
          </Typography>
          <br />
          <Responsive
            medium={
              <div>
                <div style={styles.flex}>
                  <div style={styles.leftColB}>
                    <div style={styles.flexB}>
                      <SimpleForm
                        style={{ width: "100%" }}
                        form="process-rental"
                        onSubmit={this.handleSubmit}
                        toolbar={null}
                      >
                        <React.Fragment>
                          <FormControlLabel
                            control={
                              <Switch
                                name="r_gps"
                                id="r_gps"
                                checked={this.state.r_gps}
                                onChange={e => this.handleCheckChange(e)}
                                value="0"
                                color="primary"
                                disabled={this.state.r_gps_disabled}
                              />
                            }
                            label="GPS"
                          />
                          <br />
                          <FormControlLabel
                            control={
                              <Switch
                                name="r_insurance"
                                id="r_insurance"
                                checked={this.state.r_insurance}
                                onChange={e => this.handleCheckChange(e)}
                                disabled={this.state.r_insurance_disabled}
                                value="0"
                                color="primary"
                              />
                            }
                            label="Vip Insurance"
                          />
                          <br />
                          {/* <FormControlLabel
                          control={
                            <Switch
                              name="r_cancel_insurance"
                              id="r_cancel_insurance"
                              checked={this.state.r_cancel_insurance}
                              onChange={e => this.handleCheckChange(e)}
                              value="0"
                              color="primary"
                            />
                          }
                          label="Cancel Insurance"
                        /> */}
                          <FormControlLabel
                            control={
                              <Switch
                                name="low_seat"
                                id="low_seat"
                                checked={this.state.low_seat}
                                onChange={e => this.handleCheckChange(e)}
                                value="0"
                                color="primary"
                              />
                            }
                            label="Low Seat"
                          />
                          <br />
                          <FormControlLabel
                            control={
                              <Switch
                                name="r_single"
                                id="r_single"
                                checked={this.state.r_single}
                                onChange={e => this.handleCheckChange(e)}
                                disabled={passenger}
                                value="0"
                                color="primary"
                              />
                            }
                            label="Single"
                          />
                          <br />
                          <FormControlLabel
                            control={
                              <Switch
                                name="r_double"
                                id="r_double"
                                checked={this.state.r_double}
                                onChange={e => this.handleCheckChange(e)}
                                disabled={passenger}
                                value="0"
                                color="primary"
                              />
                            }
                            label="Double"
                          />
                          <br />
                            <FormControlLabel
                            control={
                              <Switch
                                name="r_documentacion"
                                id="r_documentacion"
                                checked={this.state.r_documentacion}
                                onChange={e => this.handleCheckChange(e)}
                                value="0"
                                color="primary"
                              />
                            }
                            label="Documents received"
                          />
                          <br />
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => this.setState({ clientDocumentsModalOpen: true })}
                            disabled={!(this.state.rental && this.state.rental.client_id)}
                          >
                            View / upload client documents
                          </Button>
                          <p>
                            <InputLabel shrink htmlFor="model-simple">
                              Model
                            </InputLabel>{" "}
                            <br />
                            <StyledSelect
                              onChange={this.handelModelChange}
                              inputProps={{
                                name: "model",
                                id: "model-simple"
                              }}
                              value={this.state.vehicle_model_1}
                            >
                              {map(item => {
                                return (
                                  <MenuItem value={item.id} key={item.id}>
                                    {item.model_name}
                                  </MenuItem>
                                );
                              }, models)}
                            </StyledSelect>
                          </p>
                          <p>
                            <InputLabel shrink htmlFor="bike-simple">
                              Motorcycle *
                            </InputLabel>
                            <br />
                            <StyledSelect
                              onChange={e =>
                                this.handleChangeItem(e, "vehicleId")
                              }
                              inputProps={{
                                name: "bike",
                                id: "bike-simple"
                              }}
                              value={this.state.vehicleId}
                            >
                              {map(item => {
                                if (item.date_2.slice(0, 10) == date_1 || this.checkOneDay(item)) {
                                  return (<MenuItem value={item.id} key={item.id}>
                                    /!\** {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                    {item.vehicle_mileage} kms) **/!\
                                  </MenuItem>)
                                } else {
                                  return (<MenuItem value={item.id} key={item.id}>
                                    {item.licence_plate} {item.renting ? "®" : ""} ({item.vehicle_color} /{" "}
                                    {item.vehicle_mileage} kms)
                                  </MenuItem>)
                                }
                              }, vehicles)}
                            </StyledSelect>
                            {this.state.vehicleId === 0 &&
                              this.getModelName1() !== "Own Motorcycle" && (
                                <StyledSpan>
                                  * Please select Motorcycle
                                </StyledSpan>
                              )}
                          </p>
                          {this.state.r_gps && (
                            <React.Fragment>
                              <InputLabel shrink htmlFor="gps-simple">
                                Gps Device *
                              </InputLabel>{" "}
                              <br />
                              <StyledSelect
                                
                                onChange={e =>
                                  this.handleChangeItem(e, "gpsDeviceId")
                                }
                                inputProps={{
                                  name: "gps",
                                  id: "gps-simple"
                                }}
                                value={this.state.gpsDeviceId}
                              >
                                <MenuItem value={""} key={""}></MenuItem>
                                {map(item => {
                                  return (
                                    <MenuItem value={item.id} key={item.id}>
                                      {item.model}
                                    </MenuItem>
                                  );
                                }, gpsDevices)}
                              </StyledSelect>
                              {this.state.gpsDeviceId === 0 &&
                                this.state.r_gps && (
                                  <StyledSpan>
                                    * Please select GPS device
                                  </StyledSpan>
                                )}
                            </React.Fragment>
                          )}
                          <br />
                          <React.Fragment>
                            <p>
                              <InputLabel shrink htmlFor="discount-simple">
                                Discount
                              </InputLabel>{" "}
                              <br />
                              <TextField
                                id="discount"
                                type="number"
                                onChange={e =>
                                  this.handleChangeItem(e, "discount")
                                }
                                value={this.state.discount}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            </p>
                          </React.Fragment>
                          <br />
                          {/*}{moment(rental.date_1).diff(Date.now(), "days") <
                            60 && ({*/}

                          <div>
                            <div style={styles.flex}>
                              <div style={styles.leftColB}>
                                <div style={styles.flex}>
                                  <React.Fragment>
                                    <p>
                                      <InputLabel shrink htmlFor="partial-simple">
                                        Partial Value to Pay
                                      </InputLabel>{" "}
                                      <br />
                                      <TextField
                                        id="partial"
                                        type="number"
                                        ref={this.partialRef}
                                        onChange={e =>
                                          this.handleChangeItem(e, "partial")
                                        }
                                        value={this.state.partial}
                                        InputLabelProps={{
                                          shrink: true
                                        }}
                                      />
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            name="checkedF"
                                            checked={this.state.checkedF}
                                            onChange={e =>
                                              this.handleCheckChangeConfirm(
                                                e,
                                                parseFloat(
                                                  valueRemaining
                                                ).toFixed(2)
                                              )
                                            }
                                            value="checkedF"
                                          />
                                        }
                                        label="Confirm value to charge!"
                                      />
                                    </p>
                                  </React.Fragment>
                                </div>
                              </div>
                              <div style={styles.rightColCenterV}>
                                <div style={styles.flexCenterV}>
                                  <React.Fragment>
                                    <AddSuplementCharge rental={rental} extraCharge={true} />
                                  </React.Fragment>
                                </div>
                              </div>
                            </div>
                          </div>
                          <p>
                            {!valid_charge && (
                              <StyledSpan>
                                * value must be greater than 0
                              </StyledSpan>
                            )}
                          </p>
                          {/*})}{*/}
                          <React.Fragment>
                            <p>
                              {/*  {rentalTotal1 <
                                rental.rental_price.toFixed(2) && (
                                  <h4>
                                    Previous Total:{" "}
                                    {rental.rental_price.toFixed(2)} €
                                  </h4>
                                )} */}
                              {/* {rentalTotal1 <
                                rental.rental_price.toFixed(2) && (
                                  <h4>
                                    Max value to refund:{" "}
                                    {maxRefundValue.toFixed(2)} €
                                  </h4>
                                )} */}
                              {valueRemaining > 0 && (
                                <h4>
                                  Total value to charge:{" "}
                                  {
                                    parseFloat(
                                      valueRemaining.toFixed(2) - extraCharges.toFixed(2)
                                    ).toFixed(2)
                                  }{" "}
                                  €
                                </h4>
                              )}
                              {extraCharges > 0 && (
                                <h4>
                                  Supplement value to charge:{" "}
                                  {parseFloat(Math.abs(extraCharges)).toFixed(2)}{" "}
                                  €
                                </h4>
                              )}
                            </p>
                            <p>{moment(rental.date_1).diff(dayActual, "days")} days left to tour date.</p>
                            <br />
                            {this.chargeTypeId(rental)}
                          </React.Fragment>
                        </React.Fragment>

                        {/* { disabled by Ricardo - testing - 20-02-2020 } */}
                        {/* {rentalTotal1 < rental.rental_price && ( */}
                        {/*
                          <React.Fragment>
                            <br />
                            <InputLabel shrink htmlFor="bike-simple">
                              Refund Charge
                            </InputLabel>
                            <br />
                            <StyledSelect
                              onChange={e =>
                                this.handleChangeItem(e, "chargeId")
                              }
                              inputProps={{
                                name: "charge",
                                id: "charge-simple"
                              }}
                              value={this.state.chargeId}
                            >
                              {map(charge => {
                                return (
                                  <MenuItem value={charge.id} key={charge.id}>
                                    {`Charge (${moment(charge.date).format(
                                      "DD-MM-YYYY"
                                    )})- Value ${charge.value.toFixed(
                                      2
                                    )} € - Refunded ${charge.refunded_value} €`}
                                    ;
                                  </MenuItem>
                                );
                              }, chargesFiltered)}
                            </StyledSelect>
                            {this.state.chargeId === 0 &&
                              rentalTotal1 < rental.rental_price && (
                                <StyledSpan>
                                  * Please select a charge to refund
                                </StyledSpan>
                              )}
                            <br />
                            <br />
                            <InputLabel shrink htmlFor="refund_value-simple">
                              Refund Value
                            </InputLabel>
                            <br />
                            <TextField
                              id="refund_value"
                              type="number"
                              onChange={e =>
                                this.handleChangeItem(e, "refund_value")
                              }
                              value={refund_value}
                              inputProps={{
                                step: 1,
                                max: rental.rental_price - rentalTotal1
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            {((rentalTotal1 < rental.rental_price &&
                              refund_value > maxRefundValue) ||
                              (rentalTotal1 < rental.rental_price &&
                                refund_value > availableChargeValue)) && (
                                <StyledSpan>* Invalid Refund Value</StyledSpan>
                              )}

                            <br />
                          </React.Fragment>
                                */}
                        {/* )} */}
                        <br />
                        <br />
                        <TextField
                          fullWidth multiline
                          id="imt_comment"
                          label="IMT Comments (if charge type not Stripe)"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "imt_comment")
                          }
                          //value={this.state.imt_comment}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <br />
                        <React.Fragment>
                          <span style={{ backgroundColor: 'yellow' }}>IMT previous comments: {this.state.imt_commentN}</span>
                        </React.Fragment>

                        <br />
                        <TextField
                          fullWidth multiline
                          id="invoice_comments"
                          label="Invoice Comments"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "invoice_comments")
                          }
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        <br />
                        <TextField
                          fullWidth multiline
                          id="extra_comments"
                          label="Comments to agent"
                          type="text"
                          onChange={e =>
                            this.handleChangeItem(e, "extra_comments")
                          }
                          value={this.state.extra_comments}
                          InputLabelProps={{
                            shrink: true
                          }}
                        />
                        {rental.from_agency && (
                          <StyledP
                            addLabel={false}
                            render={() => {
                              return "A pay link will be sent to the agency";
                            }}
                          />
                        )}
                      </SimpleForm>
                    </div>
                    <CardContent>
                      <Grid container spacing={16} direction="column">
                        <Grid item>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="resend"
                                onChange={e =>
                                  this.handleCheckResendConfirm(e)
                                }
                                value="resend"
                              />
                            }
                            label="Resend confirmation email"
                          />
                        </Grid>
                        <Grid item>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="sendFinalConfirmation"
                                checked={this.state.sendFinalConfirmation}
                                onChange={e => this.handleSendEmailCheckChange(e)}
                                value="sendFinalConfirmation"
                              />
                            }
                            label="Send final confirmation e-mail"
                          />
                        </Grid>
                        <Grid item>
                          <div>
                            <div style={styles.flex}>
                              <div style={styles.leftColB}>
                                <div style={styles.flex}>
                                  <SaveButton
                                    onClick={this.handleSaveClick}
                                    disabled={
                                      (![1, 2, 4, 6, 9].includes(getPermissionRole())) ||
                                      isOnSubmit ||
                                      (rentalTotal1 < rental.rental_price &&
                                        refund_value > maxRefundValue) ||
                                      (refund_value > availableChargeValue &&
                                        rentalTotal1 < rental.rental_price) ||
                                      //(this.state.chargeId === 0 &&
                                      //  rentalTotal1 < rental.rental_price) ||
                                      (this.state.vehicleId === 0 &&
                                        this.getModelName1() !== "Own Motorcycle") ||
                                      (this.state.gpsDeviceId === 0 && this.state.r_gps)||
                                      this.state.form_error
                                    }
                                    saving={isOnSubmit}
                                  />
                                </div>
                              </div>
                              <div style={styles.rightCol}>
                                <div style={styles.flex}>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </div>
                  <div style={styles.rightCol}>
                    <div style={styles.flex}>
                      <Card>
                        <CardContent>
                          <Paper>
                            <SimpleForm toolbar={null}>
                              <InputLabel
                                shrink
                                style={{ textAlign: "center" }}
                              >
                                Choices & Prices
                              </InputLabel>
                              <FunctionField
                                label="Tour"
                                render={() => {
                                  return rental.booking.tour.tour_name
                                    .tour_name_en;
                                }}
                              />

                              <FunctionField
                                label="P4M"
                                render={() => {
                                  if (rental.booking.p4m) {
                                    return "Yes";
                                  } else {
                                    return "No";
                                  }
                                }}
                              />

                              <FunctionField
                                label="Booking Date"
                                render={() => {
                                  return moment.utc(
                                    rental.booking.r_timestamp
                                  ).format(DATEFORMAT + " HH:mm:ss");
                                }}
                              />
                              <FunctionField
                                label="Tour Start Date"
                                render={() => {
                                  let date1 = `${moment.utc(
                                    rental.booking.tour.tour_start_date
                                  ).format(DATEFORMAT)}`;
                                  if (
                                    this.isHoliday(moment(date1), hollidays1) ||
                                    this.isWeekEnd(date_1)
                                  ) {
                                    return (
                                      <div>
                                        {date1}
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "17px"
                                          }}
                                        >
                                          &nbsp;<b>!</b>
                                        </span>
                                      </div>
                                    );
                                  }
                                  return date1;
                                }}
                              />
                              <FunctionField
                                label="Tour End Date"
                                render={() => {
                                  let date2 = `${moment.utc(
                                    rental.booking.tour.tour_end_date
                                  ).format(DATEFORMAT)}`;
                                  if (
                                    this.isHoliday(
                                      moment(date_2),
                                      hollidays2
                                    ) ||
                                    this.isWeekEnd(date_2)
                                  ) {
                                    return (
                                      <div>
                                        {date2}
                                        <span
                                          style={{
                                            color: "red",
                                            fontSize: "17px"
                                          }}
                                        >
                                          &nbsp;<b>!</b>
                                        </span>
                                      </div>
                                    );
                                  }
                                  return date2;
                                }}
                                y
                              />
                              <FunctionField
                                label="Rider days (based on effective days)"
                                render={() => {
                                  return `${efectiveDays > 0 ? efectiveDays : 0
                                    } days`;
                                }}
                              />
                              <FunctionField
                                label="First choice of motorcycle"
                                render={() => {
                                  return `${rentalTotal1} Euros`;
                                }}
                              />
                              <FunctionField
                                label="Second choice of motorcycle"
                                render={() => {
                                  return `${rentalTotal2} Euros`;
                                }}
                              />

                              {!isNil(rental.booking.p_first_name) && (
                                <FunctionField
                                  label="Passenger"
                                  render={() => {
                                    return `${rental.booking.p_first_name} ${rental.booking.p_last_name}`;
                                  }}
                                />
                              )}

                              {!isNil(rental.booking.roommate) && (
                                <FunctionField
                                  label="Roommate name"
                                  render={() => {
                                    return `${rental.booking.roommate}`;
                                  }}
                                />
                              )}
                              
                              

                              {r_gps && (
                                <FunctionField
                                  label="Gps"
                                  render={() => {
                                    return `${efectiveDays *
                                      gpsPrice} Euros (${gpsPrice} Euros/day)`;
                                  }}
                                />
                              )}
                              {r_insurance && (
                                <FunctionField
                                  label="Vip Insurance"
                                  render={() => {
                                    return `${efectiveDays *
                                      vipInsurancePrice} Euros (${vipInsurancePrice} Euros/day)`;
                                  }}
                                />
                              )}

                              {r_cancel_insurance && (
                                <FunctionField
                                  label="Cancel Insurance"
                                  render={() => {
                                    return `Yes (${cancelInsuranceValue1.toFixed(
                                      2
                                    )} Euros)`;
                                  }}
                                />
                              )}

                              <FunctionField
                                label="Rewards Used"
                                render={() => {
                                  return `${rental.booking.rewards} points`;
                                }}
                              />
                              {hasSuplement > 0 && (
                                <FunctionField
                                  label="Suplements"
                                  render={() => {
                                    return `${hasSuplement} Euros`;
                                  }}
                                />
                              )}
                              <FunctionField
                                label="First Choice Motorcycle"
                                render={() => {
                                  return this.getModelName(
                                    selectedVehicle
                                      ? selectedVehicle.vehicle_model_id
                                      : 2
                                  );
                                }}
                              />
                              <FunctionField
                                label="Second Choice Motorcycle"
                                render={() => {
                                  return this.getModelName(
                                    rental.booking.vehicle_model_2
                                  );
                                }}
                              />
                              <FunctionField
                                label="Cost for first choice motorcycle"
                                render={() => {
                                  return `${model1Price} Euros`;
                                }}
                              />
                              <FunctionField
                                label="Cost for second choice motorcycle"
                                render={() => {
                                  return `${model2Price} Euros`;
                                }}
                              />

                              <FunctionField
                                label="Comments"
                                render={() => {
                                  return rental.booking.r_comments;
                                }}
                              />
                              <FunctionField
                                label="Allergy/Special Diet"
                                render={() => {
                                  return rental.booking.r_allergy_special_diet || "";
                                }}
                              />
                              <FunctionField
                                label="Client Passport"
                                render={() => {
                                  const passport = rental.booking && Number(rental.booking.is_for) === 2
                                    ? rental.booking.r_passport
                                    : rental.driver.passport;
                                  return `${isNil(passport) ? "N/A" : passport}`;
                                }}
                              />
                              <FunctionField
                                label="Driving Licence"
                                render={() => {
                                  const licence = rental.booking && Number(rental.booking.is_for) === 2
                                    ? rental.booking.r_license
                                    : rental.driver.driving_licence;
                                  return `${isNil(licence) ? "N/A" : licence}`;
                                }}
                              />
                              <FunctionField
                                label="Card Data"
                                render={() => {
                                  return `${isNil(rental.clientData)
                                    ? "N/A"
                                    : rental.clientData
                                    }`;
                                }}
                              />
                            </SimpleForm>
                          </Paper>
                          {/* <ChargesGrid
                            rental={rental}
                            charges={charges}
                            reloadData={e => this.fetchData(e, this)}
                            estados={this.state}
                          /> */}
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </CardContent>
      </Card>
      <ClientDocumentsModal
        open={this.state.clientDocumentsModalOpen}
        onClose={() => this.setState({ clientDocumentsModalOpen: false })}
        clientId={documentTarget(this.state.rental).clientId}
        rentalId={documentTarget(this.state.rental).rentalId}
      />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  state: state
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit
};

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(ProcessTourEdit)
);



// WEBPACK FOOTER //
// ./src/components/processTourEdit.js